/**
 * A marca Consult Networks.
 *
 * O ícone é o arquivo original; o wordmark é *escrito* em Ibarra Real Nova, e
 * não uma imagem — assim ele acompanha o tema, permanece nítido em qualquer
 * densidade de tela e continua legível por leitor de tela.
 */

export type TamanhoMarca = 'pequeno' | 'medio' | 'grande';

interface MarcaProps {
  /** `completa` mostra ícone e nome; `icone` serve à sidebar recolhida. */
  variante?: 'completa' | 'icone';
  tamanho?: TamanhoMarca;
  /** Em fundo escuro (a sidebar) o nome precisa inverter para branco. */
  invertido?: boolean;
  className?: string;
}

const MEDIDAS: Record<TamanhoMarca, { icone: number; texto: string; espaco: string }> = {
  pequeno: { icone: 28, texto: 'text-[15px]', espaco: 'gap-2' },
  medio: { icone: 38, texto: 'text-[19px]', espaco: 'gap-2.5' },
  grande: { icone: 56, texto: 'text-[28px]', espaco: 'gap-3.5' },
};

export function Marca({
  variante = 'completa',
  tamanho = 'medio',
  invertido = false,
  className = '',
}: MarcaProps) {
  const m = MEDIDAS[tamanho];

  const icone = (
    <img
      src="/marca/icone.png"
      width={m.icone}
      height={m.icone}
      alt=""
      // alt vazio e aria-hidden: o ícone é decorativo porque o nome ao lado já
      // é texto de verdade. Descrever os dois faria o leitor de tela repetir.
      aria-hidden="true"
      className="shrink-0 select-none"
      style={{ width: m.icone, height: m.icone }}
    />
  );

  if (variante === 'icone') {
    return (
      <span className={className} title="Consult Networks">
        {icone}
        <span className="sr-only">Consult Networks</span>
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center ${m.espaco} ${className}`}>
      {icone}
      <span
        className={`font-marca leading-[1.05] tracking-[0.01em] ${m.texto} ${
          invertido ? 'text-white' : 'text-marca'
        }`}
      >
        {/* Duas linhas, como no logotipo original. */}
        <span className="block">Consult</span>
        <span className="block">Networks</span>
      </span>
    </span>
  );
}
